import { EmptyGuid } from "./emptyGuid";
import {getWizardStateFromLocal, injectWizardStateToForm} from './wizardStateHelpers';
import { luscinia } from "./luscinia";
import { addBootgridData } from "./addBootgridData";

export class WizardStepConfiguration {
    formActions: any;
    allowNextOrPreviousStep: boolean;
    nextStepIndex: number;
    wizardState: WizardState;

    constructor() {
        this.allowNextOrPreviousStep = true;
        this.nextStepIndex = -1;
        this.wizardState = new WizardState();
    }
}

export class WizardState {
    finishBtnEnabled: boolean;
    wizardStepStates: WizardStepState[];
    parameterSyncActions: any;
    finalStepJobRunId: string;
    constructor() {
        this.finishBtnEnabled = true;
        this.finalStepJobRunId = EmptyGuid.value;
    }
}

export class WizardStepState {
    name: string;
    enabled: boolean;
    required: boolean;
    visible: boolean;
    activeJobRunId: string;
    isJobBlocking: boolean;

    constructor() {
        this.name = "";
        this.enabled = true;
        this.required = true;
        this.visible = true;
        this.activeJobRunId = EmptyGuid.value;
        this.isJobBlocking = true;
    }
}

luscinia.initWizard = function () {
    if ($('.wizard-ux').length !== 0) {
        ($('.wizard-ux') as any).wizard();

        let wizardForm = $(".block-wizard").find("form") as JQuery<HTMLFormElement>;
        var stepName = $(".block-wizard").find(".steps").find("li.active").data("stepname");
        let wizardId = "#" + $('.wizard-ux').attr("id");
        let parameterName = $(".block-wizard").data("parameter");

        luscinia.initFormElements($(".block-wizard")[0], $(".block-wizard").find("form"));

        let wizardState = getWizardStateFromLocal();
        luscinia.applyWizardState(wizardForm, wizardState);

        //Postvalue change for columns
        $(wizardForm).find("[data-" + luscinia.data.postValueChanged + "]").on("change", function () {
            postValueChange.call(this, wizardForm, parameterName);
        });

        $('.wizard-ux').on('changed', function () {
            //delete $.fn.slider;
            ($('.bslider') as any).slider();
        });

        var waitingHtml = "<div id='loadingIcon' style='float:left'><i class='fa fa-spinner fa-pulse fa-3x fa-fw'> </i></div>";
        $(".wizard-next").click(function (e) {
            var nextBtn = $(this);
            if (!nextBtn.attr("disabled")) {
                luscinia.performNextStep(nextBtn, wizardForm, waitingHtml, parameterName);
                e.preventDefault();
            }
        });

        $(".wizard-previous").click(function (e) {
            if (!$(this).attr("disabled")) {
                var stepName = $(".block-wizard").find(".steps").find("li.active").data("stepname");
                var serializedForm = luscinia.serializeFormObject(wizardForm);
                addBootgridData(serializedForm, wizardForm);
                injectWizardStateToForm(serializedForm);
                let wizardId = $(this).data("wizard");
                $.ajax({
                    method: "POST",
                    cache: false,
                    contentType: false,
                    processData: false,
                    url: `/wizard/${parameterName}/previous/${stepName}`,
                    data: serializedForm
                }).done(function (configuration: WizardStepConfiguration) {
                    luscinia.applyWizardState(wizardForm, configuration.wizardState);
                    luscinia.executeActionList(configuration.formActions, wizardForm);
                    if (configuration.allowNextOrPreviousStep) {
                        var nextIndex = luscinia.getClosestEnabledStepIndex(configuration.wizardState, configuration.nextStepIndex + 1, false);
                        if (nextIndex !== -1) {
                            ($(wizardId) as any).wizard('selectedItem', {
                                step: nextIndex + 1 //+1 because fuelix's wizards starts counting at 1
                            });
                        }
                    }
                });
                e.preventDefault();
            }
        });

        $(".wizard-complete").click(function (e) {
            var completeBtn = $(this);
            if (!completeBtn.attr("disabled")) {
                e.preventDefault();
                if (!completeBtn.hasClass("blocked")) {
                    var serializedForm = luscinia.serializeFormObject(wizardForm);
                    addBootgridData(serializedForm, wizardForm);
                    injectWizardStateToForm(serializedForm);

                    var stepName = $(".block-wizard").find(".steps").find("li.active").data("stepname");
                    let wizardId = completeBtn.data("wizard");
                    completeBtn.parent().prepend(waitingHtml);
                    completeBtn.attr("disabled", "");
                    completeBtn.removeClass("wizard-complete");
                    $.ajax({
                        type: "POST",
                        url: $(wizardForm).attr("action") + "/" + stepName,
                        data: serializedForm,
                        contentType: false,
                        processData: false
                    }).done(function (configuration: WizardStepConfiguration) {
                        luscinia.applyWizardState(wizardForm, configuration.wizardState);
                        luscinia.executeActionList(configuration.formActions, wizardForm);
                        if (configuration.allowNextOrPreviousStep) {
                            ($(wizardId) as any).wizard('selectedItem', {
                                step: configuration.nextStepIndex + 1 //+1 because fuelix's wizards starts counting at 1
                            });
                        }
                        luscinia.insertJobOverview(configuration.wizardState, -1, wizardForm);
                        luscinia.refreshValidation([], wizardForm, "#wizardFormId");
                    }).fail(function (response) {
                        let errorMessageOrErrorList = response.responseJSON !== undefined ? response.responseJSON : response.responseText;
                        luscinia.refreshValidation(errorMessageOrErrorList, wizardForm, "#wizardFormId");
                    }).always(function () {
                        $("#loadingIcon").remove();
                        completeBtn.removeAttr("disabled");
                        completeBtn.addClass("wizard-complete");
                    });
                }
            }
        });

        let serializedForm = luscinia.serializeFormObject(wizardForm);
        addBootgridData(serializedForm, wizardForm);
        injectWizardStateToForm(serializedForm);
        
        $.ajax({
            type: "POST",
            url: `/wizard/${parameterName}/onafterinitialize/${stepName}`,
            data: serializedForm,
            contentType: false,
            processData: false
        }).done(function (configuration: WizardStepConfiguration) {
            luscinia.applyWizardState(wizardForm, configuration.wizardState);
            luscinia.executeActionList(configuration.formActions, wizardForm);

            if (configuration.allowNextOrPreviousStep) {
                ($(wizardId) as any).wizard('selectedItem', {
                    step: configuration.nextStepIndex + 1 //+1 because fuelix's wizards starts counting at 1
                });
            }
            if ($(wizardId).hasClass("traversable")) {
                $('.wizard-ux').on('click', 'ul.steps > li', function () {
                    var wizardState = getWizardStateFromLocal();
                    var stepIndex = luscinia.getWizardStepIndex(wizardState, $(this).data("stepname"));
                    if (stepIndex !== null) {
                        if (wizardState.wizardStepStates[stepIndex].enabled) {
                            luscinia.performNextStep($(".wizard-next:visible"), wizardForm, waitingHtml, parameterName).done(function () {
                                ($(wizardId) as any).wizard('selectedItem', {
                                    step: stepIndex + 1 //+1 because fuelix's wizards starts counting at 1
                                });
                            });
                        }
                    }
                });
            }
        });
    }
};
luscinia.performNextStep = function (wizardNextBtn: JQuery<any>, wizardForm: JQuery<HTMLFormElement>, waitingHtml: string, parameterName: string) {
    var nextBtn = $(wizardNextBtn);
    var stepName = $(".block-wizard").find(".steps").find("li.active").data("stepname");
    var serializedForm = luscinia.serializeFormObject(wizardForm);
    addBootgridData(serializedForm, wizardForm);
    injectWizardStateToForm(serializedForm);

    let wizardId = nextBtn.data("wizard");
    nextBtn.parent().prepend(waitingHtml);
    nextBtn.attr("disabled", "");
    return $.ajax({
        type: "POST",
        url: `/wizard/${parameterName}/next/${stepName}`,
        data: serializedForm,
        processData: false,
        contentType: false
    }).done(function (configuration: WizardStepConfiguration) {
        luscinia.applyWizardState(wizardForm, configuration.wizardState);
        luscinia.executeActionList(configuration.formActions, wizardForm);
        if (configuration.allowNextOrPreviousStep) {
            var nextIndex = luscinia.getClosestEnabledStepIndex(configuration.wizardState, configuration.nextStepIndex - 1, true);
            if (nextIndex !== -1) {
                ($(wizardId) as any).wizard('selectedItem', {
                    step: nextIndex + 1 //+1 because fuelix's wizards starts counting at 1
                });
            }
            luscinia.insertJobOverview(configuration.wizardState, nextIndex, wizardForm);
            luscinia.refreshValidation([], wizardForm, "#wizardFormId");
        }
    }).fail(function (response) {
        let errorMessageOrErrorList = response.responseJSON !== undefined ? response.responseJSON : response.responseText;
        luscinia.refreshValidation(errorMessageOrErrorList, wizardForm, "#wizardFormId");
    }).always(function () {
        $("#loadingIcon").remove();
        nextBtn.removeAttr("disabled");
    });
}
luscinia.getClosestEnabledStepIndex = function (state: WizardState, currentIndex: number, forward: boolean) {
    let wizardStepList: WizardStepState[] = Object["values"](state.wizardStepStates);
    if (forward) {
        for (let i = currentIndex + 1; i < wizardStepList.length; i++) {
            var nextStep = wizardStepList[i];
            if (nextStep.enabled) {
                return i;
            }
        }
    }
    else {
        for (let i = currentIndex - 1; i >= 0; i--) {
            var previousStep = wizardStepList[i];
            if (previousStep.enabled) {
                return i;
            }
        }
    }
    return -1;
};

luscinia.getWizardStepName = function (state: WizardState, index: number) {
    if (state.wizardStepStates.length > index && index >= 0) {
        return state.wizardStepStates[index].name;
    }
    return undefined;
};

luscinia.getWizardStepState = function (state: WizardState, name: string) {
    for (let stepState of state.wizardStepStates) {
        if (stepState.name === name) {
            return stepState;
        }
    }
    return null;
};

luscinia.getWizardStepIndex = function (state: WizardState, name: string) {
    let index = 0;
    for (let stepState of state.wizardStepStates) {
        if (stepState.name === name) {
            return index;
        }
        index++;
    }
    return null;
};

luscinia.insertJobOverview = function (state: WizardState, stepIndex: number, wizardForm: JQuery<HTMLFormElement>) {
    let nextStepName = luscinia.getWizardStepName(state, stepIndex);
    if (nextStepName !== null && nextStepName !== undefined && nextStepName !== "") {
        let currentStepState = luscinia.getWizardStepState(state, nextStepName) as WizardStepState;
        if (currentStepState.activeJobRunId !== null && currentStepState.activeJobRunId !== EmptyGuid.value) {
            $.get("/data/jobruns/overview?id=" + currentStepState.activeJobRunId, function (data) {
                let contentTab = $(wizardForm).find("#tab" + stepIndex);
                var jobOverview = contentTab.find(".joboverview");
                if (jobOverview.length > 0) {
                    jobOverview.replaceWith(data);
                }
                else {
                    let contentGroups = contentTab.find(".grid");
                    if (contentGroups.length > 0) {
                        contentGroups.last().after(data);
                    }
                    else {
                        contentTab.children().first().insertBefore(data);
                    }
                }
                luscinia.initUpdateJobOverview(contentTab);

                if (currentStepState.isJobBlocking) {
                    luscinia.setStepBtnsEnabled(false, contentTab);

                    var updateWizardJobStatus = function () {
                        $.post("/data/jobruns/jobfinished", { jobRunId: currentStepState.activeJobRunId }, function (finished) {
                            if (finished === true) {
                                luscinia.setStepBtnsEnabled(true, contentTab);
                            }
                        }).then(function () {
                            if ($(`.joboverview[logId='${currentStepState.activeJobRunId}']`).length > 0) {
                                setTimeout(updateWizardJobStatus, 500);
                            }
                        });
                    };

                    updateWizardJobStatus();
                }
            });
        }
    }
    else {
        if (state.finalStepJobRunId !== null && state.finalStepJobRunId !== EmptyGuid.value) {
            $.get("/data/jobruns/overview?id=" + state.finalStepJobRunId, function (data) {
                let contentTab = $(wizardForm).find(".step-pane.finish-pane");
                var jobOverview = contentTab.find(".joboverview");
                if (jobOverview.length > 0) {
                    jobOverview.replaceWith(data);
                }
                else {
                    contentTab.html(data);
                }
                luscinia.initUpdateJobOverview(contentTab);
            });
        }
    }
};

luscinia.setStepBtnsEnabled = function (enabled: boolean, contentTab: JQuery<HTMLElement>) {
    if (enabled) {
        contentTab.find(".wizard-previous").removeAttr("disabled");
    }
    else {
        contentTab.find(".wizard-previous").attr("disabled", "");
    }
    var nextBtn = contentTab.find(".wizard-next");
    if (nextBtn.length > 0) {
        if (enabled) {
            nextBtn.removeAttr("disabled");
        }
        else {
            nextBtn.attr("disabled", "");
        }
    }
    else {
        if (enabled) {
            contentTab.find(".wizard-complete").removeAttr("disabled");
        }
        else {
            contentTab.find(".wizard-complete").attr("disabled", "");
        }
    }
};

luscinia.runWizardAction = function (actionName: string) {
    let wizardForm = $(".block-wizard").find("form") as JQuery<HTMLFormElement>;
    let parameterName = $(".block-wizard").data("parameter");

    var stepName = $(".block-wizard").find(".steps").find("li.active").data("stepname");
    var formData = luscinia.serializeFormObject(wizardForm);
    addBootgridData(formData, wizardForm);
    injectWizardStateToForm(formData);
    $.ajax({
        method: "POST",
        cache: false,
        contentType: false,
        processData: false,
        url: `/wizard/${parameterName}/action/${stepName}/${actionName}`,
        data: formData
    }).done(function (configuration: WizardStepConfiguration) {
        luscinia.applyWizardState(wizardForm, configuration.wizardState);
        luscinia.executeActionList(configuration.formActions, wizardForm);
    });
};

export function postValueChange(this: HTMLElement, wizardForm: JQuery<HTMLFormElement>, parameterName: any, overrideName: string = null, additionalData: FormData = null) {
    let name: string;
    if (overrideName !== null) {
        name = overrideName.replace("parameter-", "");
    }
    else {
         name = ($(this).attr("name") as string).replace("parameter-", "");
    }
    var stepName = $(".block-wizard").find(".steps").find("li.active").data("stepname");
    var formData = luscinia.serializeFormObject(wizardForm);
    injectWizardStateToForm(formData);

    if (additionalData !== null) {
        for (var pair of additionalData.entries()) {
            formData.append(pair[0], pair[1]);
        }
    }

    $.ajax({
        method: "POST",
        contentType: false,
        processData: false,
        url: `/wizard/${parameterName}/${stepName}` + "/valuechanged/" + name,
        data: formData
    }).done(function (configuration: WizardStepConfiguration) {
        luscinia.applyWizardState(wizardForm, configuration.wizardState);
        luscinia.executeActionList(configuration.formActions, wizardForm);
    });
}

luscinia.isWizardPage = function() {
    return $('#wizardcontainer').length > 0;
}